import {createFileRoute} from '@tanstack/react-router'
import {type} from 'arktype'

import guestRoute from '@/auth/middleware/guestRoute'
import searchParamString from '@/utils/schema/searchParamString'

const signUpSearchSchema = type({
  redirect: searchParamString.optional(),
})

export const Route = createFileRoute('/auth/sign-up')({
  validateSearch: signUpSearchSchema,
  beforeLoad: ({context, search}) => {
    guestRoute(context.store, search.redirect)
  },
})
